import script from "./PlaceAdForJob.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaceAdForJob.vue?vue&type=script&setup=true&lang=js"

import "./PlaceAdForJob.vue?vue&type=style&index=0&id=70529ad4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70529ad4"]])

export default __exports__